import { values } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { InitiatePixPayment } from "../../../Hooks/UsePix";
import { ModalLoader } from "../../Atoms/ModalLoader";
import { Container, Content, AvatarContent, ComponentTitle } from "./styles";

interface IContacts {
  name: string;
}

interface IProps {
  recurrentContacts: IContacts[];
  transferType: string;
  refreshLoading: any;
}

export const RecurrentContact = ({
  recurrentContacts,
  refreshLoading,
  transferType,
}: IProps) => {
  const history = useHistory();
  const {
    handlePOST: fetchInitiatePayment,
    state: initiatePaymentState,
    loading: initiatePaymentLoading,
    success: initiatePaymentSuccess,
  } = InitiatePixPayment();
  const [loadingTransferInformation, setLoadingTransferInformation] =
    useState(false);

  const handleSelectRecurrentContact = useCallback((value) => {
    refreshLoading(true);
    if (transferType === "pix") {
      let payload = {
        mode: "key",
        key: {
          type: value.keyType,
          value: value.pixKey,
        },
      };

      fetchInitiatePayment(payload);
    }
  }, []);

  useEffect(() => {
    if (initiatePaymentSuccess.POST && !!initiatePaymentState) {
      refreshLoading(false);
      history.push({
        pathname: "/pix/transferencia",
        state: initiatePaymentState,
      });
    }
  }, [initiatePaymentSuccess.POST, initiatePaymentState]);

  return (
    <>
      <ComponentTitle>Trasferência rápida</ComponentTitle>
      <Container>
        {recurrentContacts.map((value) => (
          <Content
            onClick={() => {
              handleSelectRecurrentContact(value);
            }}
          >
            <AvatarContent style={{ marginRight: 40 }}>
              {!!value.name.split(" ")[0] && !!value.name.split(" ")[1]
                ? value.name.split(" ")[0].substring(0, 1) +
                  value.name.split(" ")[1].substring(0, 1)
                : value.name.split(" ")[0].substring(0, 1)}
            </AvatarContent>

            <p>{value.name}</p>
          </Content>
        ))}
      </Container>
    </>
  );
};
